import CompanyProfileDetails from './CompanyProfileDetails'

export default CompanyProfileDetails
